module.exports = __webpack_public_path__ + "static/media/icon-mark-read-hover.4845dd33.svg";